import {
  MapPin,
  ShieldCheck,
  MessageSquare,
  Zap,
  BadgeCheck,
} from "lucide-react";
import { TRUST_POINTS, withElStyle } from "../lib/_data";

const ICONS = { MapPin, ShieldCheck, MessageSquare, Zap, BadgeCheck };

export default function TrustBar() {
  return (
    <section
      {...withElStyle("trust-bar", {
        className: "relative -mt-1 bg-[#fffdf9] border-y border-[#e5e0d8]",
      })}
      data-testid="trust-bar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 py-6">
        <ul className="flex flex-wrap items-center justify-center md:justify-between gap-x-8 gap-y-4">
          {TRUST_POINTS.map((tp) => {
            const Icon = ICONS[tp.icon];
            return (
              <li
                key={tp.label}
                className="flex items-center gap-3 text-sm font-semibold text-[#2c2a29]"
              >
                <span className="w-9 h-9 rounded-full bg-[#849982]/15 text-[#849982] flex items-center justify-center">
                  <Icon className="w-4 h-4" strokeWidth={2.4} />
                </span>
                {tp.label}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
